document.addEventListener('DOMContentLoaded', () => {
  const navigation = document.querySelector('.navigation')
  const hamburger = document.getElementById('hamburger')
  const drawer = document.querySelector('.drawer')
  const body = document.body

  if (hamburger && drawer) {
    hamburger.addEventListener('click', () => {
      hamburger.classList.toggle('active')
      drawer.classList.toggle('open')
      body.classList.toggle('no-scroll')
    })

    drawer.addEventListener('click', (event) => {
      if (event.target.tagName === 'A') {
        hamburger.classList.remove('active')
        drawer.classList.remove('open')
        body.classList.remove('no-scroll')
      }
    })
  }

  document.querySelectorAll('.navigation a').forEach((anchor) => {
    anchor.addEventListener('click', () => {
      hamburger.classList.remove('active')
      navigation.classList.remove('active')
      console.log('Navigation link clicked')
    })
  })

  const controls = {
    albums: {
      items: document.querySelectorAll('.music-release'),
      nextButton: document.getElementById('music-next'),
      backButton: document.getElementById('music-back'),
      pageNav: document.querySelector('.music-page-nav'),
      pageIndicator: document.querySelector('.music-page-indicator'),
      perPage: {
        mobile: 1,
        tablet: 10,
        desktop: 10,
      },
    },
    videos: {
      items: document.querySelectorAll('.thumbnail'),
      nextButton: document.getElementById('video-next'),
      backButton: document.getElementById('video-back'),
      pageNav: document.querySelector('.video-page-nav'),
      pageIndicator: document.querySelector('.video-page-indicator'),
      perPage: {
        mobile: 1,
        tablet: 3,
        desktop: 4,
      },
    },
  }

  const state = {
    albums: {
      currentPage: 1,
      itemsPerPage: 1,
      items: Array.from(document.querySelectorAll('.music-release')),
    },
    videos: {
      currentPage: 1,
      itemsPerPage: 1,
      items: Array.from(document.querySelectorAll('.thumbnail')),
    },
  }

  const updateItemsPerPage = (key) => {
    const screenWidth = window.innerWidth
    console.log('Screen width:', screenWidth)
    const config = controls[key].perPage

    if (screenWidth >= 960) {
      state[key].itemsPerPage = config.desktop
    } else if (screenWidth >= 720) {
      state[key].itemsPerPage = config.tablet
    } else {
      state[key].itemsPerPage = config.mobile
    }
  }

  const displayCurrentPage = (key) => {
    const { itemsPerPage, currentPage } = state[key]
    const { items, pageIndicator, nextButton, backButton, pageNav } =
      controls[key]

    // Calculate total pages
    const totalPages = Math.ceil(items.length / itemsPerPage)
    console.log(`${key} total pages:`, totalPages) // Debugging: Check total pages calculation

    // Display or hide items based on the current page
    const startIndex = (currentPage - 1) * itemsPerPage
    const endIndex = startIndex + itemsPerPage

    items.forEach((item, index) => {
      if (index >= startIndex && index < endIndex) {
        item.classList.remove('hidden')
      } else {
        item.classList.add('hidden')
      }
    })

    // Handle visibility of the page-nav for this context
    if (pageNav) {
      if (totalPages <= 1) {
        pageNav.style.display = 'none' // Hide if only 1 page exists
      } else {
        pageNav.style.display = 'flex' // Show for multiple pages
      }
    }

    // Adjust opacity of navigation buttons
    if (backButton && nextButton) {
      if (currentPage === 1) {
        backButton.style.opacity = '0.5' // Disable back button
        nextButton.style.opacity = totalPages > 1 ? '1' : '0.5' // Enable or disable next button
      } else if (currentPage === totalPages) {
        backButton.style.opacity = '1' // Enable back button
        nextButton.style.opacity = '0.5' // Disable next button
      } else {
        backButton.style.opacity = '1' // Enable both buttons
        nextButton.style.opacity = '1'
      }
    }

    // Update page indicator
    if (pageIndicator) {
      pageIndicator.textContent = `${currentPage}/${totalPages}`
    }
  }

  const goToNextPage = (key) => {
    const { items, itemsPerPage, currentPage } = state[key]

    // Check if items are available before accessing length
    if (!items || items.length === 0) {
      console.error(`No items found for ${key}`)
      return // Exit if no items are available
    }

    const totalPages = Math.ceil(items.length / itemsPerPage)

    if (currentPage < totalPages) {
      state[key].currentPage++
      displayCurrentPage(key)
    }
  }

  const goToPreviousPage = (key) => {
    const { items } = state[key]

    // Check if items are available before accessing length
    if (!items || items.length === 0) {
      console.error(`No items found for ${key}`)
      return // Exit if no items are available
    }

    if (state[key].currentPage > 1) {
      state[key].currentPage--
      displayCurrentPage(key)
    }
  }

  const handleResize = () => {
    Object.keys(controls).forEach((key) => {
      const previousItemsPerPage = state[key].itemsPerPage
      updateItemsPerPage(key)

      if (state[key].itemsPerPage !== previousItemsPerPage) {
        state[key].currentPage = 1
      }

      displayCurrentPage(key)
    })
  }

  Object.keys(controls).forEach((key) => {
    const { nextButton, backButton } = controls[key]
    if (nextButton) {
      nextButton.addEventListener('click', () => goToNextPage(key))
    }
    if (backButton) {
      backButton.addEventListener('click', () => goToPreviousPage(key))
    }
  })

  window.addEventListener('resize', handleResize)
  Object.keys(controls).forEach((key) => {
    updateItemsPerPage(key)
    displayCurrentPage(key)
  })
})
